import PageHero from "@/components/layout/PageHero";
import QuoteForm from "@/components/sections/QuoteForm";
import Contact from "@/components/sections/Contact";

const Orcamento = () => (
  <>
    <PageHero
      eyebrow="Orçamento rápido"
      title="Solicite seu Orçamento"
      description="Preencha o formulário e receba um orçamento personalizado em até 2 horas."
    />
    <QuoteForm showHeading={false} />
    <Contact />
  </>
);

export default Orcamento;
